(function () {
  'use strict';

  const STORAGE_KEY = 'dar-assalam-recently-viewed';
  const MAX_STORED = 20;
  const SECTION_ID = 'RecentlyViewed';
  const GRID_ID = 'RecentlyViewedGrid';
  const CLEAR_ID = 'RecentlyViewedClear';

  // ──────────────────────────────────────────
  // localStorage Helpers
  // ──────────────────────────────────────────
  function getViewed() {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (_) {
      return [];
    }
  }

  function saveViewed(handles) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(handles.slice(0, MAX_STORED)));
    } catch (_) {}
  }

  function addViewed(handle) {
    if (!handle) return;
    const viewed = getViewed().filter((h) => h !== handle);
    viewed.unshift(handle); // newest first
    saveViewed(viewed);
  }

  function clearViewed() {
    try { localStorage.removeItem(STORAGE_KEY); } catch (_) {}
  }

  // ──────────────────────────────────────────
  // Track current product on PDP
  // ──────────────────────────────────────────
  // Detect via body class (template-product) AND meta refresh of current handle
  const section = document.getElementById(SECTION_ID);
  const currentHandle = section ? section.dataset.currentHandle : '';

  // Fallback detection if no section on page: check URL pattern /products/{handle}
  let trackedHandle = currentHandle;
  if (!trackedHandle && /^\/products\/[^\/]+/.test(window.location.pathname)) {
    trackedHandle = window.location.pathname.split('/products/')[1].split(/[\/?#]/)[0];
  }
  if (trackedHandle) addViewed(trackedHandle);

  // ──────────────────────────────────────────
  // Render section (if present on this page)
  // ──────────────────────────────────────────
  if (!section) return;

  const grid = document.getElementById(GRID_ID);
  const clearBtn = document.getElementById(CLEAR_ID);
  const maxProducts = parseInt(section.dataset.maxProducts) || 8;

  function money(cents) {
    return new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' }).format(cents / 100);
  }

  function productCardHTML(p) {
    const img = p.featured_image
      ? (p.featured_image.startsWith('//') ? 'https:' + p.featured_image : p.featured_image)
      : '';
    const imgUrl = img ? img.replace(/(\.[a-z]+)(\?|$)/i, '_400x$1$2') : '';
    return ''
      + '<article class="product-card" data-product-handle="' + p.handle + '">'
      +   '<a href="/products/' + p.handle + '" class="product-card__link">'
      +     '<div class="product-card__image-wrap">'
      +       (imgUrl ? '<img src="' + imgUrl + '" alt="" class="product-card__img" loading="lazy">' : '<div class="product-card__img" style="background:var(--color-cream-dark);"></div>')
      +     '</div>'
      +     '<div class="product-card__info">'
      +       '<p class="product-card__category">' + (p.type || p.vendor || '') + '</p>'
      +       '<h3 class="product-card__title">' + p.title + '</h3>'
      +       '<div class="jdgm-widget jdgm-preview-badge product-card__jdgm" data-id="' + p.id + '"></div>'
      +       '<div class="product-card__price-row">'
      +         '<span class="product-card__price">' + money(p.price) + '</span>'
      +         '<span class="btn btn--small btn--outline-dark">Kaufen</span>'
      +       '</div>'
      +     '</div>'
      +   '</a>'
      + '</article>';
  }

  async function fetchProduct(handle) {
    try {
      const r = await fetch('/products/' + encodeURIComponent(handle) + '.js');
      if (!r.ok) return null;
      return await r.json();
    } catch (_) {
      return null;
    }
  }

  async function render() {
    const allHandles = getViewed().filter((h) => h && h !== currentHandle);
    if (allHandles.length === 0) {
      section.hidden = true;
      return;
    }

    const handles = allHandles.slice(0, maxProducts);
    const results = await Promise.all(handles.map(fetchProduct));
    const products = results.filter(Boolean);

    if (products.length === 0) {
      section.hidden = true;
      return;
    }

    grid.innerHTML = products.map(productCardHTML).join('');
    section.hidden = false;

    // Re-render Judge.me badges nachdem DOM neu ist
    if (window.jdgm && typeof window.jdgm.customizeBadges === 'function') {
      window.jdgm.customizeBadges();
    }
  }

  if (clearBtn) {
    clearBtn.addEventListener('click', () => {
      clearViewed();
      section.hidden = true;
    });
  }

  render();
})();
